var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/navigation-items.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/navigation-items.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
if(t_1.hasOwnProperty("brandsUrl")) {
var t_5 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_5);
if(t_1.hasOwnProperty("helpUrl")) {
var t_6 = t_1.helpUrl;
} else {
cb(new Error("cannot import 'helpUrl'")); return;
}
context.setVariable("helpUrl", t_6);
if(t_1.hasOwnProperty("categoryUrl")) {
var t_7 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
["navItem"], 
[], 
function (l_navItem, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItem", l_navItem);
var t_9 = "";t_9 += "\n    ";
if(l_navItem) {
t_9 += "\n        ";
var t_10;
t_10 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("url", t_10, true);
if(frame.topLevel) {
context.setVariable("url", t_10);
}
if(frame.topLevel) {
context.addExport("url", t_10);
}
t_9 += "\n        ";
var t_11;
t_11 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("target", t_11, true);
if(frame.topLevel) {
context.setVariable("target", t_11);
}
if(frame.topLevel) {
context.addExport("target", t_11);
}
t_9 += "\n\n        ";
if(runtime.memberLookup((l_navItem),"typeCode") == "BRAND") {
t_9 += "\n            ";
var t_12;
t_12 = (lineno = 8, colno = 32, runtime.callWrap(t_5, "brandsUrl", context, []));
frame.set("url", t_12, true);
if(frame.topLevel) {
context.setVariable("url", t_12);
}
if(frame.topLevel) {
context.addExport("url", t_12);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "CONTENT") {
t_9 += "\n            ";
var t_13;
t_13 = (lineno = 10, colno = 30, runtime.callWrap(t_6, "helpUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_13, true);
if(frame.topLevel) {
context.setVariable("url", t_13);
}
if(frame.topLevel) {
context.addExport("url", t_13);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "CONTENT_NN") {
t_9 += "\n            ";
var t_14;
t_14 = (lineno = 12, colno = 30, runtime.callWrap(t_6, "helpUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_14, true);
if(frame.topLevel) {
context.setVariable("url", t_14);
}
if(frame.topLevel) {
context.addExport("url", t_14);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "DEFAULT") {
t_9 += "\n            ";
var t_15;
t_15 = (lineno = 14, colno = 34, runtime.callWrap(t_7, "categoryUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_15, true);
if(frame.topLevel) {
context.setVariable("url", t_15);
}
if(frame.topLevel) {
context.addExport("url", t_15);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "SMART") {
t_9 += "\n            ";
var t_16;
t_16 = (lineno = 16, colno = 34, runtime.callWrap(t_7, "categoryUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_16, true);
if(frame.topLevel) {
context.setVariable("url", t_16);
}
if(frame.topLevel) {
context.addExport("url", t_16);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "EXTERNAL") {
t_9 += "\n\n            ";
var t_17;
t_17 = runtime.memberLookup((l_navItem),"targetUrlTarget");
frame.set("target", t_17, true);
if(frame.topLevel) {
context.setVariable("target", t_17);
}
if(frame.topLevel) {
context.addExport("target", t_17);
}
t_9 += "\n            ";
var t_18;
t_18 = env.getFilter("default").call(context, runtime.memberLookup((l_navItem),"relativeFlag"),runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("isRelative", t_18, true);
if(frame.topLevel) {
context.setVariable("isRelative", t_18);
}
if(frame.topLevel) {
context.addExport("isRelative", t_18);
}
t_9 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "isRelative") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"siteIdToContextPathMappings")),runtime.memberLookup((l_navItem),"targetUrl"))) {
t_9 += "\n                ";
t_9 += "\n                ";
var t_19;
t_19 = (lineno = 24, colno = 37, runtime.callWrap(t_4, "genericUrl", context, [runtime.memberLookup((l_navItem),"targetUrl"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core"),"excludeContextPath": runtime.contextOrFrameLookup(context, frame, "True")})]));
frame.set("url", t_19, true);
if(frame.topLevel) {
context.setVariable("url", t_19);
}
if(frame.topLevel) {
context.addExport("url", t_19);
}
t_9 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isRelative") && !runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"siteIdToContextPathMappings")),runtime.memberLookup((l_navItem),"targetUrl"))) {
t_9 += "\n                ";
var t_20;
t_20 = (lineno = 26, colno = 37, runtime.callWrap(t_4, "genericUrl", context, [runtime.memberLookup((l_navItem),"targetUrl"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core"),"excludeContextPath": runtime.contextOrFrameLookup(context, frame, "False")})]));
frame.set("url", t_20, true);
if(frame.topLevel) {
context.setVariable("url", t_20);
}
if(frame.topLevel) {
context.addExport("url", t_20);
}
t_9 += "\n            ";
;
}
else {
t_9 += "\n                ";
var t_21;
t_21 = runtime.memberLookup((l_navItem),"targetUrl");
frame.set("url", t_21, true);
if(frame.topLevel) {
context.setVariable("url", t_21);
}
if(frame.topLevel) {
context.addExport("url", t_21);
}
t_9 += "\n            ";
;
}
;
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "GATEWAY") {
t_9 += "\n            ";
var t_22;
t_22 = (lineno = 31, colno = 34, runtime.callWrap(t_7, "categoryUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_22, true);
if(frame.topLevel) {
context.setVariable("url", t_22);
}
if(frame.topLevel) {
context.addExport("url", t_22);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "GATEWAY_NN") {
t_9 += "\n            ";
var t_23;
t_23 = (lineno = 33, colno = 34, runtime.callWrap(t_7, "categoryUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_23, true);
if(frame.topLevel) {
context.setVariable("url", t_23);
}
if(frame.topLevel) {
context.addExport("url", t_23);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "HEADING") {
t_9 += "\n            ";
var t_24;
t_24 = (lineno = 35, colno = 34, runtime.callWrap(t_7, "categoryUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_24, true);
if(frame.topLevel) {
context.setVariable("url", t_24);
}
if(frame.topLevel) {
context.addExport("url", t_24);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "HOME_COLLE") {
t_9 += "\n            ";
var t_25;
t_25 = (lineno = 37, colno = 34, runtime.callWrap(t_7, "categoryUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_25, true);
if(frame.topLevel) {
context.setVariable("url", t_25);
}
if(frame.topLevel) {
context.addExport("url", t_25);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "NONPRODUCT") {
t_9 += "\n            ";
var t_26;
t_26 = (lineno = 39, colno = 34, runtime.callWrap(t_7, "categoryUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_26, true);
if(frame.topLevel) {
context.setVariable("url", t_26);
}
if(frame.topLevel) {
context.addExport("url", t_26);
}
t_9 += "\n        ";
;
}
else {
if(runtime.memberLookup((l_navItem),"typeCode") == "NO_NAV") {
t_9 += "\n            ";
var t_27;
t_27 = (lineno = 41, colno = 34, runtime.callWrap(t_7, "categoryUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_27, true);
if(frame.topLevel) {
context.setVariable("url", t_27);
}
if(frame.topLevel) {
context.addExport("url", t_27);
}
t_9 += "\n        ";
;
}
else {
t_9 += "\n            ";
var t_28;
t_28 = (lineno = 43, colno = 34, runtime.callWrap(t_7, "categoryUrl", context, [runtime.memberLookup((l_navItem),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("url", t_28, true);
if(frame.topLevel) {
context.setVariable("url", t_28);
}
if(frame.topLevel) {
context.addExport("url", t_28);
}
t_9 += "\n        ";
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
t_9 += "\n\n        ";
t_9 += runtime.suppressValue((lineno = 46, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [l_navItem,runtime.contextOrFrameLookup(context, frame, "url"),runtime.contextOrFrameLookup(context, frame, "target")])), env.opts.autoescape);
t_9 += "\n    ";
;
}
t_9 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
context.addExport("renderNavItem");
context.setVariable("renderNavItem", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/navigation-items.j2"] , dependencies)